<template>
  <div class="evollu-form">
    <div class="row">
      <div class="col-12">
        <label class="form-label">{{$t('users.clone.from')}}</label>
        <multiselect
          v-model="form.fromUser"
          :internal-search="false"
          :options="filteredFromUserOptions"
          track-by="id"
          label="name"
          deselect-label="×"
          :placeholder="$t('users.clone.placeholders.select_user')"
          :searchable="true"
          :allow-empty="true"
          :multiple="false"
          :show-labels="false"
          :disabled="true"
          :limit="25"
          :limitText="count => $t('clusters.placeholders.and_more', {count})"
          >
          <span slot="noResult">{{$t('patients.noResults')}}</span>
          <template slot="singleLabel" slot-scope="{ option }">
            <span>{{option.name}} ({{option.entity.name}})</span>
          </template>
          <template slot="option" slot-scope="{ option }">
            <span>{{option.name}} ({{option.entity.name}})</span>
          </template>
          <template slot="tag" slot-scope="{ option }">
            <span class="custom__tag">
              <span>{{ option.name }} ({{option.entity}})</span>
            </span>
          </template>
        </multiselect>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <label class="form-label">{{$t('users.clone.to')}}</label>
        <multiselect
          v-model="form.toUser"
          :internal-search="false"
          @search-change="search => usersSearch = search.toLowerCase()"
          :options="filteredToUserOptions"
          track-by="id"
          label="name"
          deselect-label="×"
          :placeholder="$t('users.clone.placeholders.select_user')"
          :searchable="true"
          :allow-empty="true"
          :multiple="false"
          :show-labels="false"
          :limit="25"
          :limitText="count => $t('clusters.placeholders.and_more', {count})"
          >
          <span slot="noResult">{{$t('patients.noResults')}}</span>
          <template slot="singleLabel" slot-scope="{ option }">
            <span>{{option.name}} ({{option.entity.name}})</span>
          </template>
          <template slot="option" slot-scope="{ option }">
            <span>{{option.name}} ({{option.entity.name}})</span>
          </template>
        </multiselect>
      </div>
    </div>

  </div>
</template>
<script>
import { UserService } from '@/api/AuthService'
import Multiselect from 'vue-multiselect'
export default {
  components: {
    Multiselect
  },
  props: {
    to: {
      type: Object,
      required: false
    },
    from: {
      type: Object,
      required: false
    },
    cloneForm: {
      type: Object,
      required: true,
      validator: (value) => {
        return value.hasOwnProperty('fromUser') && value.hasOwnProperty('toUser')
      }
    },
    options: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      form: {
        fromUser: null,
        toUser: null
      },
      users: [],
      usersSearch: '',
    }
  },
  mounted () {
    this.form = { ...this.cloneForm }
    this.createUsersDataset()
  },
  methods: {
    createUsersDataset: function () {
      return new Promise((resolve, reject) => {
        UserService.query({ ...this.options })
          .then(response => {
            this.users = response.filter(element => element.id !== this.$auth.user().id)
              .map(user => {
                // TODO: Load entity relation properly ...
                return {
                  ...user,
                  entity: {
                    name: user.entity
                  }
                }
              })
              .sort((a, b) => a.name.localeCompare(b.name))
            resolve()
          })
          .catch(errors => reject(errors))
      })
    }
  },
  computed: {
    filteredFromUserOptions: function () {
      let filteredOptions = []

      if (this.usersSearch.trim()) {
        filteredOptions = this.users.filter(element => {
          return element.name.toLowerCase().includes(this.usersSearch) || element.entity.name.toLowerCase().includes(this.usersSearch)
        })
      } else {
        filteredOptions = this.users
      }
      if (this.form.toUser) {
        filteredOptions = filteredOptions.filter(element => element.id !== this.form.toUser.id)
      }

      return filteredOptions
    },
    filteredToUserOptions: function () {
      let filteredOptions = []

      if (this.usersSearch.trim()) {
        filteredOptions = this.users.filter(element => {
          return element.name.toLowerCase().includes(this.usersSearch) || element.entity.name.toLowerCase().includes(this.usersSearch)
        })
      } else {
        filteredOptions = this.users
      }

      if (this.form.fromUser) {
        filteredOptions = filteredOptions.filter(element => element.id !== this.form.fromUser.id)
      }

      return filteredOptions
    },
  },
  watch: {
    form: {
      handler: function (value) {
        this.$emit('update:cloneForm', value)
      },
      deep: true
    }
  }
}
</script>
